import { FeatureFlag } from 'types/features';
import { useHasPermissions } from 'utils/permissionUtil';
import { useIsFeatureEnabled } from 'utils/useFeatureFlags';

export const usePartyAssetPermissions = () => {
    const enabled = useIsFeatureEnabled(FeatureFlag.PARTY_ASSETS);
    return {
        canRead: useHasPermissions(['READ.PARTY_ASSETS']) && enabled,
        canCreate: useHasPermissions(['CREATE.PARTY_ASSETS']) && enabled,
        canUpdate: useHasPermissions(['UPDATE.PARTY_ASSETS']) && enabled,
        canDelete: useHasPermissions(['DELETE.PARTY_ASSETS']) && enabled,
        /** The fund accounts and a client's cases, which the form reads, are open to any of these. */
        canUseForm: useHasPermissions(['READ.PARTY_ASSETS', 'CREATE.PARTY_ASSETS', 'UPDATE.PARTY_ASSETS']) && enabled,
    };
};
